(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyne-foot-cart"]) return;
  try {
    
  (() => {
    if (window.VyneCartDrawerReady) return;
    window.VyneCartDrawerReady = true;
    let lastTrigger = null;

    const drawer = () => document.getElementById('VyneCartDrawer');
    const panel = () => drawer()?.querySelector('.vyne-drawer__panel');
    const root = () => window.Shopify?.routes?.root || '/';

    const openDrawer = () => {
      const current = drawer();
      if (!current) return;
      current.classList.add('is-open');
      current.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vyne-cart-locked');
      requestAnimationFrame(() => panel()?.focus());
    };

    const closeDrawer = () => {
      const current = drawer();
      if (!current) return;
      current.classList.remove('is-open');
      current.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vyne-cart-locked');
      lastTrigger?.focus();
    };

    const refreshDrawer = async (shouldOpen = true) => {
      const response = await fetch(`${root()}?section_id=vyne-foot-cart`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to refresh cart');
      const markup = await response.text();
      const next = new DOMParser().parseFromString(markup, 'text/html').getElementById('VyneCartDrawer');
      const current = drawer();
      if (next && current) current.replaceWith(next);
      if (shouldOpen) openDrawer();
    };

    const boundWidgets = new WeakSet();

    const syncBundleButton = (widget) => {
      const form = widget?.closest('.vyne-product-form');
      const submit = form?.querySelector('button[type="submit"][name="add"]');
      if (!submit || form.dataset.vyneAdding === 'true') return;
      const inStock = form.dataset.vyneAvailable === 'true';
      const valid = inStock && typeof widget.isItemSelectionValid === 'function' && widget.isItemSelectionValid();
      submit.disabled = !valid;
      submit.textContent = valid ? 'Add to cart' : (inStock ? 'Choose your bundle' : 'Sold out');
    };

    const bindBundle = (widget) => {
      if (!widget?.closest('.vyne-product-form') || boundWidgets.has(widget)) return;
      boundWidgets.add(widget);
      widget.addEventListener('items-changed', () => syncBundleButton(widget));
      widget.addEventListener('deal-bar-selected', () => syncBundleButton(widget));
      syncBundleButton(widget);
    };

    document.addEventListener('kaching-bundles-block-loaded', (event) => bindBundle(event.detail.component));
    document.querySelectorAll('kaching-bundles-block').forEach(bindBundle);

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.vyne-product-form');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.dataset.vyneAdding === 'true') return;
      const widget = form.querySelector('kaching-bundles-block');
      const submit = event.submitter || form.querySelector('[type="submit"]');
      const oldNotice = form.querySelector('[data-vyne-cart-error]');
      oldNotice?.remove();
      lastTrigger = submit;
      try {
        if (!widget || typeof widget.validateItemSelection !== 'function') {
          throw new Error('Your bundle is still loading. Please try again.');
        }
        if (form.dataset.vyneAvailable !== 'true') {
          throw new Error('This product is currently unavailable.');
        }
        const { valid } = widget.validateItemSelection();
        if (!valid) return;
        const items = widget.items();
        if (!items.length) return;
        form.dataset.vyneAdding = 'true';
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
        }
        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
          credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add your bundle. Please try again.');
        }
        await refreshDrawer(true);
      } catch (error) {
        const notice = document.createElement('p');
        notice.dataset.vyneCartError = '';
        notice.setAttribute('role', 'alert');
        notice.textContent = error.message || 'Unable to add your bundle. Please try again.';
        form.appendChild(notice);
      } finally {
        delete form.dataset.vyneAdding;
        if (submit) submit.removeAttribute('aria-busy');
        syncBundleButton(widget);
      }
    }, true);

    document.addEventListener('click', async (event) => {
      const close = event.target.closest('[data-vyne-cart-close]');
      if (close) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      const cartLink = event.target.closest('[data-vyne-cart-open], a[href="/cart"], a[href$="/cart"]');
      if (cartLink && !event.target.closest('[name="checkout"]')) {
        event.preventDefault();
        lastTrigger = cartLink;
        openDrawer();
        return;
      }

      const change = event.target.closest('[data-vyne-cart-change]');
      if (!change) return;
      event.preventDefault();
      change.disabled = true;
      try {
        const response = await fetch(`${root()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.quantity) }),
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Unable to update cart');
        await refreshDrawer(true);
      } finally {
        change.disabled = false;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer()?.classList.contains('is-open')) closeDrawer();
    });

    if (new URLSearchParams(window.location.search).get('cart') === 'open') openDrawer();
    if (window.location.pathname.replace(/\/$/, '') === `${root().replace(/\/$/, '')}/cart`) openDrawer();
  })();

  } catch(e) { console.error(e); }
})();
})();
